import {
    MCFormisFieldText,
    MCFormisFieldAutoComplete,
    //MCFormisFieldCustomHidden
    MCFullRowWrapperComponent,
    MCPanelWrapperComponent,
    MCFormisFieldCheckbox,
    MCFormisFieldTextarea,
    MCFormisFieldAlpha,
    MCFormisFieldAttachment,
    //MCFormisFieldArray,
    //MIFormisFieldArray,
    MCFormisFieldCalendar,
    MCFormisFieldHtmlDisplay,
    MCFormisFieldInfo,
    MCFormisFieldNumeric,
    MCFormisFieldSubTitle,
    MCFormisFieldCustomHidden,
    MCFormisFieldRadio,
} from '@maslul/common-components';
//import { MCFormisFieldCalendar } from '../../app/components/features/request/pages/request-details/formis-field-calendar/formis-field-calendar';
import { MIFormisFieldArray } from '../../app/components/common/formis-field-array/formis-field-array';
import { FormlyFieldConfig } from '@ngx-formly/core';


export const customFormlyConfig = {
    types: [
        { name: 'date', component: MCFormisFieldCalendar, extends: 'input' },
        { name: 'numeric', component: MCFormisFieldNumeric, extends: 'input' },
        { name: 'alpha', component: MCFormisFieldAlpha, extends: 'input' },
        { name: 'hidden', component: MCFormisFieldCustomHidden },
        { name: 'text', component: MCFormisFieldText, extends: 'input' },
        { name: 'textarea', component: MCFormisFieldTextarea, extends: 'input' },
        { name: 'repeat', component: MIFormisFieldArray },
        { name: 'attachment', component: MCFormisFieldAttachment, extends: 'input' },
        { name: 'autocomplete', component: MCFormisFieldAutoComplete, extends: 'input' },
        { name: 'htmldisplay', component: MCFormisFieldHtmlDisplay },
        { name: 'subtitle', component: MCFormisFieldSubTitle },
        { name: 'info', component: MCFormisFieldInfo },
        { name: 'checkbox', component: MCFormisFieldCheckbox },
        // { name: 'label', component: MCFormisFieldLabel },
        // { name: 'repeatlabel', component: MCFormisFieldLabelArray },
        { name: 'radiobool', component: MCFormisFieldRadio, extends: 'input' },
        { name: 'radio', component: MCFormisFieldRadio, extends: 'input' }
    ],
    wrappers: [
        { name: 'panel', component: MCPanelWrapperComponent },
        { name: 'full-row', component: MCFullRowWrapperComponent }
    ],
    extensions: [
        { name: 'label-fix', extension: { postPopulate: typeLayoutExtension } },
    ],
};

const TYPES_EXTENDING_INPUT = customFormlyConfig.types
    .filter(t => t.extends === 'input')
    .map(t => t.name);

function typeLayoutExtension(field: FormlyFieldConfig) {
    if (field.type && TYPES_EXTENDING_INPUT.includes(field.type as string)) {
        if (!field.wrappers || field.wrappers.length === 0) {
            field.wrappers = ['form-field'];
        }
    }
}